import { FacebookSearchContainer } from "../Containers/FacebookSearchContainer"


export const FacebookSearchViewer = () => {
    return(
        <div style={{display:'flex'}}>
            <FacebookSearchContainer/>
        </div>
    )
}